/**
 * Identidad de usuario — fuente única para UI (AuthContext → currentUser).
 * Preparado para auditoría/reportes por usuario (id estable).
 */

export function getUserFullName(user) {
  if (!user) return 'Usuario';
  const fromParts = `${user.nombre || ''} ${user.apellido || ''}`.trim();
  if (fromParts) return fromParts;
  const display = String(user.displayName || '').trim();
  if (display) return display;
  const email = String(user.email || '').trim();
  if (email) return email.split('@')[0];
  return 'Usuario';
}

export function getUserInitials(user) {
  if (!user) return 'U';
  const full = getUserFullName(user);
  if (full === 'Usuario') {
    const email = String(user.email || '').trim();
    if (email) return email.charAt(0).toUpperCase();
    return 'U';
  }
  const parts = full.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(0)}`.toUpperCase();
  }
  return full.charAt(0).toUpperCase();
}

export function getUserAvatarUrl(user) {
  return user?.avatarUrl || user?.photoURL || null;
}

export function getUserRoleLabel(user) {
  const rol = String(user?.rol || '').trim();
  if (rol && rol !== 'Usuario') return rol;
  const rolId = String(user?.rolId || user?.rol_id || '').trim();
  if (!rolId) return '';
  const map = {
    admin: 'Administrador',
    gerente: 'Gerente',
    cajero: 'Cajero',
    empleado: 'Empleado'
  };
  return map[rolId.toLowerCase()] || rolId;
}

/** ID estable del usuario en el tenant (ventas, caja, auditoría futura). */
export function getUserIdentityId(user) {
  return user?.id || user?.uid || null;
}

/** Normaliza perfil recibido del backend hacia currentUser. */
export function mergeUserProfile(base, patch = {}) {
  if (!base) return patch;
  const nombre = patch.nombre ?? base.nombre;
  const apellido = patch.apellido ?? base.apellido;
  const avatarUrl = patch.avatarUrl ?? patch.photoURL ?? base.avatarUrl ?? base.photoURL ?? null;
  const displayName = `${nombre || ''} ${apellido || ''}`.trim() || base.displayName || null;
  return {
    ...base,
    ...patch,
    nombre,
    apellido,
    avatarUrl,
    photoURL: avatarUrl,
    displayName
  };
}
